import i18n from '../i18n';

/**
 * API returns case.status as: new | in_progress | completed | archived
 * (legacy responses may still use "active").
 */
export function formatCaseWorkflowStatus(status) {
  if (status == null || status === '') return '—';
  const s = String(status).toLowerCase().trim();
  const keyMap = {
    new: 'advisorPortal.workflowNew',
    in_progress: 'advisorPortal.workflowInProgress',
    pending_review: 'advisorPortal.statusPendingReview',
    waiting_on_documents: 'advisorPortal.statusWaitingOnDocuments',
    waiting_on_client: 'advisorPortal.statusWaitingOnClient',
    ready_to_submit: 'advisorPortal.statusReadyToSubmit',
    ready_to_approve: 'advisorPortal.workflowReadyToApprove',
    submitted: 'advisorPortal.statusSubmitted',
    in_review_govt: 'advisorPortal.statusInReviewGovernment',
    approved: 'advisorPortal.statusApproved',
    rejected: 'advisorPortal.statusRejected',
    cancelled_client: 'advisorPortal.statusCancelledClient',
    cancelled_internal: 'advisorPortal.statusCancelledInternal',
    expired_abandoned: 'advisorPortal.statusExpiredAbandoned',
    completed: 'advisorPortal.workflowCompleted',
    archived: 'advisorPortal.workflowArchived',
    active: 'advisorPortal.workflowInProgress',
  };
  const key = keyMap[s];
  if (key && i18n.exists(key)) {
    return i18n.t(key);
  }
  return String(status);
}

/**
 * Choose one case to highlight in the customer profile "Active case" card.
 * Prefer non-terminal workflow cases (not completed/archived), then by status rank, then recency.
 */
export function pickActiveCaseForProfile(cases) {
  if (!Array.isArray(cases) || cases.length === 0) return null;
  const norm = (s) => String(s || '').toLowerCase().trim();
  const isTerminal = (c) => {
    const s = norm(c.status);
    return s === 'completed' || s === 'archived';
  };
  const open = cases.filter((c) => !isTerminal(c));
  const pool = open.length ? open : [...cases];
  const rank = (c) => {
    const s = norm(c.status);
    if (s === 'in_progress' || s === 'active') return 4;
    if (s === 'new') return 3;
    if (s === 'draft') return 2;
    return 1;
  };
  return [...pool].sort((a, b) => {
    const dr = rank(b) - rank(a);
    if (dr !== 0) return dr;
    const ta = a.updated_at ? new Date(a.updated_at).getTime() : 0;
    const tb = b.updated_at ? new Date(b.updated_at).getTime() : 0;
    return tb - ta;
  })[0];
}
